import { Box, Typography, TextField } from '@mui/material';
import useDebounce from '../../hooks/useDebounce';
import { useState, useEffect } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/roleFiltration.css';

const RoleFiltration = ({ filtersEmpty, roleFilters, setRoleFilters, totalRoles, rolesFetched, filteredRolesCount }) => {

    const [search, setSearch] = useState(roleFilters.debouncedSearch || '');
    const debouncedSearch = useDebounce(search, 1000);

    // Update filters when debounced search changes
    useEffect(() => {
        setRoleFilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setRoleFilters]);

    return (
        <Box className='rolesFiltration_counts'>
            <Box className='rolesFiltration_wrapper'>
                <Box className='rolesFiltration_container'>

                    <TextField
                        size="small"
                        value={search}
                        placeholder='Rechercher'
                        onChange={(e) => setSearch(e.target.value)}
                        variant="outlined"
                        className='rolesFiltration_search_Box'
                        InputProps={{
                            startAdornment: <Iconify icon={"bx:bx-search"} className='rolesFiltration_search_icon' />,
                            sx: {
                                backgroundColor: '#fff',
                                height: '36px',
                                fontFamily: 'Mulish',
                                color: '#201E1E',
                                fontSize: '14px',
                                fontWeight: 400,
                            },
                        }}
                    />
                </Box>

            </Box>

            <Typography className='rolesFiltration_total_number'>
                {rolesFetched} affichés
                {!filtersEmpty && ` / ${filteredRolesCount} filtrés`}
                {` / ${totalRoles} au total`}
            </Typography>

        </Box>
    );
};

export default RoleFiltration;